<template>
  <svg viewBox="0 0 2610 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M788 1244v201l-89-79v-75c-310-53-547-324-547-649 0-6 0-11 1-16L0 516V319l230 165-1 2c-6 23-11 47-14 72-1 3-1 5-1 8-2 10-3 19-3 29-1 3-1 6-1 10-1 12-1 24-1 37 0 324 257 589 579 602zm834-925v197l-152 110v16c0 325-237 596-547 649v75l-88 79v-201c321-13 579-278 579-602 0-13-1-25-1-37-1-4-1-7-1-10-1-10-2-19-3-29 0-3-1-5-1-8-4-25-9-49-15-72v-2l48-35h1z" />
  </svg>
</template>
